<template>
    <div class="handicapped-tab">
        <div class="tabulation-title" :style="'color:' + titlesColor">
            <h5>
                {{ index }}. Accès aux personnes en situation de handicap
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <form-component-loader :fields="tabulationFields"></form-component-loader>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations} from "vuex"
    import FormComponentLoader from "../FormComponentLoader.vue"

    export default {
        name: "Handicapped",
        components: {FormComponentLoader},
        props: ['index'],
        computed: {
            ...mapState('webFormStyle', ['titlesColor']),
            ...mapGetters('web_form', ['getFieldsFromTabulation']),
            tabulationFields() {
                return this.getFieldsFromTabulation('ACCES_HANDICAPES').sort((a, b) => a.order - b.order)
            },
        }
    }
</script>
